// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    background: #fff;
    height: 70px;
    position: fixed;
    top: 0;
    right: 0;
    left: 250px;
    z-index: 100;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 2rem;
}

.header-search {
    flex: 1 1;
    max-width: 400px;
}

.search-input {
    width: 100%;
    padding: 0.5rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    font-size: 0.875rem;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.notifications {
    position: relative;
    cursor: pointer;
}

.notification-badge {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #ef4444;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-profile {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.profile {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-right: 1rem;
    border-right: 1px solid #e2e8f0;
}

.profile span {
    font-size: 0.875rem;
    color: #1a1a1a;
    font-weight: 500;
}

.logout-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background: none;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.875rem;
}

.logout-btn:hover {
    background: #fee2e2;
    border-color: #ef4444;
    color: #ef4444;
}

.logout-btn .icon {
    font-size: 1rem;
}

.icon {
    font-size: 1.25rem;
    color: #64748b;
}`, "",{"version":3,"sources":["webpack://./src/pages/components/Header.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".header {\n    background: #fff;\n    height: 70px;\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 250px;\n    z-index: 100;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100%;\n    padding: 0 2rem;\n}\n\n.header-search {\n    flex: 1;\n    max-width: 400px;\n}\n\n.search-input {\n    width: 100%;\n    padding: 0.5rem 1rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.5rem;\n    font-size: 0.875rem;\n}\n\n.header-right {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.notifications {\n    position: relative;\n    cursor: pointer;\n}\n\n.notification-badge {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    background: #ef4444;\n    color: white;\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    font-size: 0.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.user-profile {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.profile {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding-right: 1rem;\n    border-right: 1px solid #e2e8f0;\n}\n\n.profile span {\n    font-size: 0.875rem;\n    color: #1a1a1a;\n    font-weight: 500;\n}\n\n.logout-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    background: none;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.5rem;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 0.875rem;\n}\n\n.logout-btn:hover {\n    background: #fee2e2;\n    border-color: #ef4444;\n    color: #ef4444;\n}\n\n.logout-btn .icon {\n    font-size: 1rem;\n}\n\n.icon {\n    font-size: 1.25rem;\n    color: #64748b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
